/**
 * Get a correct format of the information about payment authorisation fail
 * @param {object} error - error details object
 * @returns {object}
 */
const paymentAuthorisationFailedInfo = (error) => {
	return {
		paymentMethod: error.paymentMethod || 'Undefined',
		message: error.account ? 'email blocked by MyAccount' : `${error.code || 'Undefined'} | ${error.subcode || 'Undefined'} | ${error.declinedMessageCode || 'Undefined'}`
	};
};

export default paymentAuthorisationFailedInfo;
